<template>
  <div>
    <div class="account-container d-flex justify-content-center align-items-center">
      <b-card class="account-card">
        <b-row>
          <b-col lg="7" md="12" sm="12">
            <b-form @submit.prevent="submitForm">
              <b-row>
                <!-- First Name -->
                <b-col lg="6" md="12" sm="12">
                  <b-form-group label="الاسم الأول">
                    <label v-if="!editable">{{ form.first_name }}</label>
                    <b-form-input v-else v-model="$v.form.first_name.$model" :state="validateState('first_name')" placeholder="الاسم الأول"></b-form-input>
                    <b-form-invalid-feedback>الاسم الاول مطلوب</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <!-- Last Name -->
                <b-col lg="6" md="12" sm="12">
                  <b-form-group label="اسم العائلة">
                    <label v-if="!editable">{{ form.last_name }}</label>
                    <b-form-input v-else v-model="$v.form.last_name.$model" :state="validateState('last_name')" placeholder="اسم العائلة"></b-form-input>
                    <b-form-invalid-feedback>اسم العائلة مطلوب</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <!-- Phone -->
                <b-col lg="6" md="12" sm="12">
                  <b-form-group label="رقم الهاتف">
                    <label v-if="!editable">{{ form.phone }}</label>
                    <phone-input v-else v-model="$v.form.phone.$model" :state="validateState('phone')"></phone-input>
                    <b-form-invalid-feedback :force-show="$v.form.phone.$error">رقم الهاتف مطلوب</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <!-- Parent Phone -->
                <b-col lg="6" md="12" sm="12">
                  <b-form-group label="رقم هاتف ولي الامر">
                    <label v-if="!editable">{{ form.parent_phone }}</label>
                    <phone-input v-else v-model="$v.form.parent_phone.$model" :state="validateState('parent_phone')"></phone-input>
                    <b-form-invalid-feedback :force-show="$v.form.parent_phone.$error">{{ $v.form.parent_phone.required ? 'رقم هاتف ولي الامر يجب أن يختلف عن رقم الطالب' : 'رقم هاتف ولي الامر مطلوب' }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <!-- Email -->
                <b-col lg="6" md="12" sm="12">
                  <b-form-group label="البريد الاكتروني">
                    <label v-if="!editable">{{ form.email }}</label>
                    <b-form-input v-else type="email" v-model="$v.form.email.$model" :state="validateState('email')"></b-form-input>
                    <b-form-invalid-feedback v-if="!$v.form.email.required">البريد الاكتروني مطلوب</b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.form.email.email">البريد الاكتروني غير صالح</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <!-- Gender -->
                <b-col lg="6" md="12" sm="12">
                  <b-form-group label="النوع">
                    <label v-if="!editable">{{ form.gender == 'male' ? 'ذكر' : 'انثى' }}</label>
                    <b-form-select v-else v-model="form.gender" :options="genderOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Save + Cancel Buttons -->
              <div v-if="editable">
                <div v-if="sendError" class="mb-2">
                  <div v-for="error in errorMessages" :key="error" class="p-2 bg-dark text-white rounded mb-1">
                    {{ error }}
                  </div>
                </div>

                <b-button :disabled="isLoading" type="submit" variant="brand" class="ml-2">
                  <span v-if="isLoading">جاري الحفظ <b-spinner small></b-spinner></span>
                  <span v-else>حفظ</span>
                </b-button>
                <b-button variant="secondary" @click="cancelEditForm()">الغاء</b-button>
              </div>
            </b-form>

            <!-- Edit Button -->
            <b-button v-if="!editable" variant="brand" class="mt-3" @click="editable = true">تعديل</b-button>

            <br>
            <!-- Toggle Password Change Button -->
            <b-button variant="brand" class="mt-3 ml-2" v-if="!showChangePassword" @click="showChangePassword = true">
              تغيير كلمة المرور
            </b-button>

            <div v-if="sendSuccess" class="mb-2 p-2 bg-success text-white rounded">تم التعديل بنجاح</div>


            <!-- Password Change Form -->
            <b-card class="mt-4" v-if="showChangePassword">
              <b-card-title>تغيير كلمة المرور</b-card-title>

              <div v-if="sendSuccess" class="mb-2 p-2 bg-success text-white rounded">تم تغيير كلمة المرور بنجاح</div>
              <div v-if="sendError" class="mb-2">
                <div v-for="error in errorMessages" :key="error" class="p-2 bg-dark text-white rounded mb-1">
                  {{ error }}
                </div>
              </div>

              <b-form @submit.prevent="submitPasswordForm">
                <b-form-group label="كلمة المرور الحالية">
                  <b-form-input type="password" v-model="$v.passwordForm.old_password.$model" :state="validatePasswordState('old_password')"></b-form-input>
                  <b-form-invalid-feedback>كلمة المرور الحالية مطلوبة</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="كلمة المرور الجديدة">
                  <b-form-input type="password" v-model="$v.passwordForm.new_password.$model" :state="validatePasswordState('new_password')"></b-form-input>
                  <b-form-invalid-feedback>كلمة المرور مطلوبة ويجب أن تكون 8 أحرف على الأقل</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="تأكيد كلمة المرور">
                  <b-form-input type="password" v-model="$v.passwordForm.new_password_confirmation.$model" :state="validatePasswordState('new_password_confirmation')"></b-form-input>
                  <b-form-invalid-feedback>كلمة المرور غير متطابقة</b-form-invalid-feedback>
                </b-form-group>

                <b-button variant="success" class="ml-2" type="submit" :disabled="isLoading">
                  <span v-if="isLoading">جاري التغيير <b-spinner small></b-spinner></span>
                  <span v-else>تغيير كلمة المرور</span>
                </b-button>
                <b-button variant="secondary" @click="showChangePassword = false">الغاء</b-button>
              </b-form>
            </b-card>
          </b-col>

          <b-col lg="5" md="12" sm="12">
            <img src="../../assets/images/login_img.png" style="width:100%; height:250px; object-fit:contain;" alt="منصة البارون">
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { sendRequest } from "../../utils/RequestHelper.js";
import store from "../../store/index.js";
import PhoneInput from "./PhoneInput.vue";

import { required, email, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  components: { PhoneInput },
  mixins: [validationMixin],
  data() {
    return {
      editable: false,
      showChangePassword: false,
      isLoading: false,
      sendSuccess: false,
      sendError: false,
      errorMessages: [],
      form: {
        first_name: '',
        last_name: '',
        phone: '',
        parent_phone: '',
        email: '',
        gender: '',
      },
      passwordForm: {
        old_password: '',
        new_password: '',
        new_password_confirmation: '',
      },
      genderOptions: [
        { value: 'male', text: 'ذكر' },
        { value: 'female', text: 'انثى' },
      ],
    };
  },
  validations: {
    form: {
      first_name: { required },
      last_name: { required },
      phone: { required },
      parent_phone: {
        required,
        differsFromPhone(value) {
          return !value || value !== this.form.phone;
        },
      },
      email: { required, email },
    },
    passwordForm: {
      old_password: { required },
      new_password: { required, minLength: minLength(8) },
      new_password_confirmation: { required, sameAsPassword: sameAs('new_password') },
    },
  },
  methods: {
    validateState(field) {
      const { $dirty, $error } = this.$v.form[field];
      return $dirty ? !$error : null;
    },
    validatePasswordState(field) {
      const { $dirty, $error } = this.$v.passwordForm[field];
      return $dirty ? !$error : null;
    },
    submitForm() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) return;
      this.changeData();
    },
    submitPasswordForm() {
      this.$v.passwordForm.$touch();
      if (this.$v.passwordForm.$anyError) return;
      this.changePassword();
    },
    changeData() {
      this.isLoading = true;
      this.sendError = false;
      this.sendSuccess = false;
      const data = { ...this.form };
      sendRequest('patch', 'auth/profile/', true, data,
        () => {
          this.sendSuccess = true;
          this.isLoading = false;
          setTimeout(() => { this.getData(); this.editable = false; }, 3000);
        },
        (apiError) => {
          this.errorMessages = [];
          const errors = apiError.errors || {};
          if (errors.email) this.errorMessages.push('البريد الالكتروني موجود بالفعل');
          if (errors.phone) this.errorMessages.push('رقم الهاتف موجود بالفعل');
          if (errors.parent_phone) this.errorMessages.push('رقم هاتف ولي الامر يجب أن يختلف عن رقم الطالب');
          if (!this.errorMessages.length) this.errorMessages.push('تعذر حفظ البيانات. من فضلك حاول مرة أخرى');
          this.sendError = true;
          this.isLoading = false;
        }
      );
    },
    changePassword() {
      this.isLoading = true;
      this.sendError = false;
      this.sendSuccess = false;
      this.errorMessages = [];

      const data = { ...this.passwordForm };

      sendRequest('post', 'auth/change-password/', true, data,
        () => {
          this.sendSuccess = true;
          this.isLoading = false;
          this.passwordForm.old_password = '';
          this.passwordForm.new_password = '';
          this.passwordForm.new_password_confirmation = '';
          this.$v.passwordForm.$reset();
          this.showChangePassword = false;

          setTimeout(() => {
            this.sendSuccess = false;
          }, 3000);
        },
        (apiError) => {
          this.sendError = true;
          this.isLoading = false;
          const errors = apiError.errors || {};
          if (errors.old_password) this.errorMessages.push('كلمة المرور الحالية غير صحيحة');
          if (errors.new_password) this.errorMessages.push('كلمة المرور الجديدة ضعيفة أو مطابقة للحالية');
          if (errors.new_password_confirmation) this.errorMessages.push('كلمة المرور غير متطابقة');
          if (!this.errorMessages.length) this.errorMessages.push('حدث خطأ في كلمة المرور');
        }
      );
    },
    getData() {
      sendRequest('get', 'auth/profile/', true, null,
        (data) => {
          this.form.first_name = data.first_name;
          this.form.last_name = data.last_name;
          this.form.phone = data.phone;
          this.form.parent_phone = data.parent_phone;
          this.form.email = data.email;
          this.form.gender = data.gender;
        },
        () => { this.isLoading = false; }
      );
    },
    cancelEditForm() {
      this.getData();
      this.editable = false;
    },
  },
  created() {
    if (store.state.token) {
      this.getData();
    } else {
      this.$router.push({ name: 'login' });
    }
  }
};
</script>

<style scoped>
.account-container {
  background: #f8f9fa;
}
.account-card {
  margin: 60px 0;
  width: 80%;
  border-radius: 10px;
}
.is-invalid {
  border: 2px solid red !important;
}

@media (max-width: 767.98px) {
  .account-card {
    margin: 24px 0;
    width: calc(100% - 24px);
  }
}
</style>
